import { Collection } from 'modules/core/lib/mobx-rest'

import UserPreference from 'modules/bookkeepers/store/models/UserPreference'

class UserPreferences extends Collection<UserPreference> {
  get cacheKey(): string {
    return 'bookkeepersUserPreferences'
  }

  model() {
    return UserPreference
  }
}

export default new UserPreferences()
